<template>
  <div class="connection-indicator" :class="{ clickable: clickable && display }" :title="result && result.error" @click="emitClick">
    <img :src="logo" class="connection-icon" />
    <template v-if="display">
      <i v-if="result.success" class="result-icon fal fa-check-circle success"></i>
      <i v-else class="result-icon fal fa-exclamation-circle error"></i>
    </template>
    <div v-else class="result-icon fal fa-spinner fa-spin loading"></div>
  </div>
</template>

<script>
export default {
  props: {
    logo: {
      type: String,
      required: true
    },

    testAction: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      display: false,
      result: null
    }
  },

  computed: {
    clickable () {
      return this.$listeners.click
    }
  },

  methods: {
    emitClick () {
      console.log('emit')
      if (this.display && this.$listeners.click) {
        this.$emit('click', this.error)
      }
    }
  },

  created () {
    this.$store.dispatch(this.testAction).then(response => {
      this.display = true
      this.result = response

      if (response.error) {
        console.error(response.error)
        this.error = response.error
      }
    }).catch(error => {
      console.error(error)
      this.display = true
      this.result = {
        success: false,
        error: 'Testkoppling misslyckades'
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.connection-indicator {
  position: relative;

  &.clickable {
    cursor: pointer;
  }

  .connection-icon {
    width: 30px;
    margin-left: 1rem;
  }

  .result-icon {
    $size: 1.3rem;

    position: absolute;
    right: -0.3rem;
    top: -0.3rem;
    border-radius: 50% 50%;
    width: $size;
    height: $size;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;

    &.success {
      background-color: rgba(0, 155, 16, 0.8);
    }
    &.error {
      background-color: rgba(255, 0, 0, 0.7);
    }

    &.loading {
      background-color: rgba(200, 200, 200, 0.7);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other/ConnectionIndicator.vue